const loadedScripts = {};

/**
 * Load an external script once and resolve when it is ready
 * @param {string} src Script URL
 * @returns {Promise<void>}
 */
export function loadScript(src) {
  if (!loadedScripts[src]) {
    loadedScripts[src] = new Promise((resolve, reject) => {
      const script = document.createElement('script');

      script.src = src;
      script.async = true;
      script.onload = () => resolve();
      script.onerror = () => {
        delete loadedScripts[src];
        reject(new Error(`Failed to load script ${src}`));
      };

      document.head.appendChild(script);
    });
  }

  return loadedScripts[src];
}
